import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';
import { hideConfirmModal, showConfirmModal } from 'redux-store/reducers/modal-reducer';
import {
  trackEventProfileCoverImageUploaded,
  trackEventProfileImageUploaded
} from '../../tracking/utils/tracking';

import { createReducer } from 'utils/redux';
import { API, post } from 'utils/api';
import { t } from 'utils/language';
import { logError } from 'utils/log';

const CHANGE_IMAGE = 'influencerImages/CHANGE_IMAGE';
const RECEIVE_INFLUENCER_IMAGES = 'influencerImages/RECEIVE_INFLUENCER_IMAGES';
const RESET_INFLUENCER_IMAGES = 'influencerImages/RESET_INFLUENCER_IMAGES';

const { IMAGES } = API.END_POINTS.API;

const initialState = {
  coverImage: null,
  profileImage: null
};

export function resetInfluencerImages() {
  return {
    type: RESET_INFLUENCER_IMAGES,
    payload: {}
  };
}

export function receiveInfluencerImages(data) {
  return {
    type: RECEIVE_INFLUENCER_IMAGES,
    payload: {
      data
    }
  };
}

function changeInfluencerImage(type, data) {
  return {
    type: CHANGE_IMAGE,
    payload: {
      type,
      data
    }
  };
}

export function uploadImage(influencerProfile, type, image) {
  const url = IMAGES;

  return (dispatch) => {
    if (!image.file) {
      // just area was updated
      return Promise.resolve(dispatch(changeInfluencerImage(type, image)))
        .then(() => image);
    }

    dispatch(showLoading(url));

    const data = new FormData();

    data.append('file', image.file);

    return post(url, { data })
      .then((response) => {
        const createdImage = {
          area: image.area,
          ...response.data
        };

        if (type === 'cover') {
          trackEventProfileCoverImageUploaded('influencer');
        } else {
          trackEventProfileImageUploaded('influencer');
        }

        dispatch(changeInfluencerImage(type, createdImage));
        dispatch(hideLoading(url));

        return createdImage;
      })
      .catch((error) => {
        const errorMessage = t(type === 'cover' ? 'cover_image_upload_error' : 'profile_image_upload_error');

        dispatch(showConfirmModal({
          message: errorMessage,
          confirmButtonLabel: t('action_button_ok'),
          onConfirm: () => dispatch(hideConfirmModal())
        }));

        dispatch(hideLoading(url));
        logError(error);

        throw error;
      });
  };
}

export default createReducer('influencerImages', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET_INFLUENCER_IMAGES]: () => initialState,
  [RECEIVE_INFLUENCER_IMAGES]: (state, { data }) => ({
    ...state,
    coverImage: data.coverImage,
    profileImage: data.profileImage
  }),
  [CHANGE_IMAGE]: (state, { type, data }) => ({
    ...state,
    [`${type}Image`]: data
  })
});
